import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../../symbols';
import { format } from '@/@core/utils/string';
let OperationCenterApi = class OperationCenterApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    getProductLine(product_line_type) {
        return this.http.get({
            url: this.urls.getProductLine,
            params: {
                product_line_type,
            },
        });
    }
    postProductLine(params) {
        return this.http.post({
            url: this.urls.postProductLine,
            data: {
                ...params,
            },
        });
    }
    deleteProductLine(product_line_id) {
        const url = format(this.urls.deleteProductLine, { product_line_id });
        return this.http.delete({
            url,
        });
    }
    getResourceSpaceList(product_line_id) {
        const url = format(this.urls.getResourceSpaceList, { product_line_id });
        return this.http.get({
            url,
        });
    }
    postResourceSpace(params) {
        const url = format(this.urls.postResourceSpace, { product_line_id: params.product_line_id });
        return this.http.post({
            url,
            data: params,
        });
    }
    getResourceSpace(resource_space_id) {
        const url = format(this.urls.getResourceSpace, { resource_space_id });
        return this.http.get({
            url,
        });
    }
    putResourceSpace(params) {
        return this.http.put({
            url: this.urls.putResourceSpace,
            data: params,
        });
    }
    deleteResourceSpace(resource_space_id) {
        const url = format(this.urls.deleteResourceSpace, { resource_space_id });
        return this.http.delete({
            url,
        });
    }
    deleteResourceSpaceContent(resource_space_content_id) {
        const url = format(this.urls.deleteResourceSpaceContent, { resource_space_content_id });
        return this.http.delete({
            url,
        });
    }
    getResourceSpaceContentPagination(params) {
        return this.http.get({
            url: this.urls.getResourceSpaceContentPagination,
            params,
        });
    }
    makeResourceSpaceContentParams(params) {
        const formData = new FormData();
        if (params.image) {
            formData.append('image', params.image);
        }
        if (params.rule_user_excel) {
            formData.append('rule_user_excel', params.rule_user_excel);
        }
        formData.append('content', JSON.stringify(params.content));
        return formData;
    }
    postResourceSpaceContent(params) {
        return this.http.postForm({
            url: this.urls.postResourceSpaceContent,
            data: this.makeResourceSpaceContentParams(params),
        });
    }
    putResourceSpaceContent(params) {
        return this.http.putForm({
            url: this.urls.putResourceSpaceContent,
            data: this.makeResourceSpaceContentParams(params),
        });
    }
    postResourceSpaceContentClone(resource_space_content_id) {
        const url = format(this.urls.postResourceSpaceContentClone, { resource_space_content_id });
        return this.http.post({
            url,
        });
    }
    getResourceSpaceContentOnShelvesCheck(resource_space_content_id) {
        const url = format(this.urls.getResourceSpaceContentOnShelvesCheck, { resource_space_content_id });
        return this.http.get({
            url,
        });
    }
    postResourceSpaceContentOnShelves(resource_space_content_id) {
        const url = format(this.urls.postResourceSpaceContentOnShelves, { resource_space_content_id });
        return this.http.post({
            url,
        });
    }
    getResourceSpaceContentOffShelvesCheck(resource_space_content_id) {
        const url = format(this.urls.getResourceSpaceContentOffShelvesCheck, { resource_space_content_id });
        return this.http.get({
            url,
        });
    }
    postResourceSpaceContentOffShelves(resource_space_content_id) {
        const url = format(this.urls.postResourceSpaceContentOffShelves, { resource_space_content_id });
        return this.http.post({
            url,
        });
    }
    getResourceSpaceContentDetail(content_id) {
        const url = format(this.urls.getResourceSpaceContentDetail, { content_id });
        return this.http.get({
            url,
        });
    }
    getResourceSpaceContentDetailHistory(params, resource_space_content_id) {
        const url = format(this.urls.getResourceSpaceContentDetailHistory, { resource_space_content_id });
        return this.http.get({
            url,
            params,
        });
    }
};
OperationCenterApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.OperationCenterUrls)),
    __metadata("design:paramtypes", [Object, Object])
], OperationCenterApi);
export { OperationCenterApi };
